import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/item-info/board-game-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/item-info/game-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/item-info/movie-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/item-info/series-info.tsx");
